// import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InfoIcon from "@mui/icons-material/Info";
import { useTabsStyles, useTabItemStyles } from "./TimelineTooltipTabsStyles";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

const TooltipTabs = ({
  tabIndex,
  setTabIndex,
  disableMoreInfo,
}: {
  tabIndex: number;
  setTabIndex: (index: number) => void;
  disableMoreInfo: boolean;
}) => {
  const tabsStyles = useTabsStyles();
  const tabItemStyles = useTabItemStyles();
  const { translate } = useFlightTranslation();
  const [
    {
      general: { timelineTooltipShowCounts },
    },
  ] = useFlightConfig();
  return (
    <Tabs
      classes={tabsStyles}
      className={`timelineTooltipTabs tab-${tabIndex}`}
      variant="fullWidth"
      value={tabIndex}
      onChange={(e, index) => setTabIndex(index)}
    >
      <Tab classes={tabItemStyles} label={translate("About")} />
      <Tab
        className="timeline-tooltip-more-info-tab"
        classes={tabItemStyles}
        label={
          timelineTooltipShowCounts ? "Count, SKU" : translate("More_Info")
        }
        icon={<InfoIcon />}
        disabled={disableMoreInfo}
      />
    </Tabs>
  );
};

export default TooltipTabs;
